import React from "react";
import { createListTableColumns, renderOptionalName, ShimmeredDetailsList } from "sprint-common-web";

import { renderActionStatus } from "../../../../common/utils/renderActionStatus";
import { renderContent } from "../../../common/components/listings/renderContent";
import { OrderRequestListingItem } from "../OrderRequestListingItem";
import { ProcessSendOrderRequestItem, SendOrderRequestItem } from "./SendOrderRequestItem";

interface SendOrderRequestSummaryProps {
    items: ProcessSendOrderRequestItem[];
}

export const SendOrderRequestSummaryList: React.VFC<SendOrderRequestSummaryProps> = ({
    items
}: SendOrderRequestSummaryProps) => {
    const columns = createListTableColumns<ProcessSendOrderRequestItem>([
        {
            type: "basic",
            key: "pONumber",
            name: "PO Number",
            minWidth: 75,
            maxWidth: 90
        },
        {
            type: "basic",
            key: "content",
            name: "Content",
            minWidth: 75,
            maxWidth: 160,
            onRender: renderContent
        },
        {
            type: "basic",
            key: "airline",
            name: "Airline",
            minWidth: 45,
            maxWidth: 100,
            onRender: renderOptionalName
        },
        {
            type: "basic",
            key: "system",
            name: "System",
            minWidth: 48,
            maxWidth: 80,
            onRender: renderOptionalName
        },
        {
            type: "basic",
            key: "processStatus",
            name: "Process status",
            minWidth: 100,
            onRender: renderActionStatus
        }
    ]);

    return <ShimmeredDetailsList columns={columns} items={items} layoutMode="fixedColumns" />;
};

export const mapToSendOrderRequestItem = (orderRequest: OrderRequestListingItem): SendOrderRequestItem => {
    return {
        id: orderRequest.id,
        content: orderRequest.content,
        contentType: orderRequest.contentType,
        version: orderRequest.version,
        pONumber: orderRequest.pONumber,
        airline: orderRequest.airline,
        status: orderRequest.status,
        system: orderRequest.system,
        isTrailer: orderRequest.isTrailer
    };
};
